import React from "react";
import { BrowserRouter, HashRouter, Switch } from "react-router-dom";
import { AlisFatura_Screen } from "../screens/alisfatura/alisfatura";
import { HomePagecopy_Screen } from "../screens/homepagecopy/homepagecopy";
import { SairDekontList_Screen } from "../screens/sairdekontlist/sairdekontlist";
import { BankaDetay_Screen } from "../screens/bankadetay/bankadetay";
import { MasrafList_Screen } from "../screens/masraflist/masraflist";
import { SKoleksiyonBazindaSatis_Screen } from "../screens/skoleksiyonbazindasatis/skoleksiyonbazindasatis";
import { UEAKoleksiyonStok_Screen } from "../screens/ueakoleksiyonstok/ueakoleksiyonstok";
import { SatisFatura_Screen } from "../screens/satisfatura/satisfatura";
import { KasaList_Screen } from "../screens/kasalist/kasalist";
import { EbatDetaySatis_Screen } from "../screens/ebatdetaysatis/ebatdetaysatis";
import { UEADesenStok_Screen } from "../screens/ueadesenstok/ueadesenstok";
import { MusteriList_Screen } from "../screens/musterilist/musterilist";
import { KrediKartiList_Screen } from "../screens/kredikartilist/kredikartilist";
import { LeftMenu_Screen } from "../screens/leftmenu/leftmenu";
import { UrunEnvanterAnalizi_Screen } from "../screens/urunenvanteranalizi/urunenvanteranalizi";
import { Signup_Screen } from "../screens/signup/signup";
import { MusteriDetay_Screen } from "../screens/musteridetay/musteridetay";
import { TedarikciDetay_Screen } from "../screens/tedarikcidetay/tedarikcidetay";
import { UrunSatisAnaliz_Screen } from "../screens/urunsatisanaliz/urunsatisanaliz";
import { HomePage_Screen } from "../screens/homepage/homepage";
import { DesenDetaySatis_Screen } from "../screens/desendetaysatis/desendetaysatis";
import { KasaDetay_Screen } from "../screens/kasadetay/kasadetay";
import { ResetPassword_Screen } from "../screens/resetpassword/resetpassword";
import { VerificationCode_Screen } from "../screens/verificationcode/verificationcode";
import { ForgotPassword_Screen } from "../screens/forgotpassword/forgotpassword";
import { AlacakCekSenetList_Screen } from "../screens/alacakceksenetlist/alacakceksenetlist";
import { BankaList_Screen } from "../screens/bankalist/bankalist";
import { Signin_Screen } from "../screens/signin/signin";
import { UEAEbatStok_Screen } from "../screens/ueaebatstok/ueaebatstok";
import { EbatDetaySatinAlma_Screen } from "../screens/ebatdetaysatinalma/ebatdetaysatinalma";
import { Test_Screen } from "../screens/test/test";
import { BorcCekSenetList_Screen } from "../screens/borcceksenetlist/borcceksenetlist";
import { UrunMaliyetAnalizi_Screen } from "../screens/urunmaliyetanalizi/urunmaliyetanalizi";
import { TedarikciList_Screen } from "../screens/tedarikcilist/tedarikcilist";
import { SAKoleksiyonBazindaSatinAlim_Screen } from "../screens/sakoleksiyonbazindasatinalim/sakoleksiyonbazindasatinalim";
import { Usercreate_Screen } from "../screens/usercreate/usercreate";
import { DesenDetaySatinAlma_Screen } from "../screens/desendetaysatinalma/desendetaysatinalma";
import { MagazaCiroAnalizi_Screen } from "../screens/magazaciroanalizi/magazaciroanalizi";
import { ProfileScreen_Screen } from "../screens/profilescreen/profilescreen";



import LocalStorageService from "../auth/local-storage-service";
import { Redirect } from "../auth/redirect";
import { IAppMode, IAuthType } from "../bootstrapper";
import { NoMatch404 } from "../components/common/no-match-404";
import { Dashboard, ForgotPassword, Login, ResetPassword } from "../components/default_screens/index";
import { KuikaInfo } from "../components/default_screens/kuika-info";
import { MfeLogin } from "../components/mfe/mfe-login";
import { MsalLogin } from "../components/msal/msal-login";
import { MsalRedirect } from "../components/msal/msal-redirect";
import { NotificationRedirect } from "../components/notification/notification-redirect";
import { ScanCompareTest } from "../screens/scan-compare-test";
import { WFMailInteraction } from "../screens/wf-mail-interaction";
import confJson from "../shared/json/conf.json";
import { KMainFunctions } from "../shared/utilty/main-functions";
import { MasterScreenWrapper } from "./master-screen-wrapper";
import { PrivateRoute } from "./private-route";
import { Route } from "./route";



export interface IRouterState {}

export type IRouterType = "HashRouter" | "BrowserRouter";

export interface IRouterProps {
  authType: IAuthType;
  routerType?: IRouterType;
  external_access_token?: string;
  external_refresh_token?: string;
  external_user?: string;
  startingScreen?: string;
  appMode?: IAppMode;
  // Allow only screenInput_* props with specific typing
  [key: `screenInput_${string}`]: unknown;
}

declare let window: any;
export class Router extends React.Component<IRouterProps, IRouterState> {
  timerId: any = null;

  private hasNavigatedToStartingScreen: boolean = false;

  componentDidMount = () => {
    // SET LANGUAGE TO HTML BODY
    const lang = LocalStorageService.getUserLanguage();
    if (lang) {
      const fixedLangAttributeValue = lang.replace("_", "-");
      document.body.setAttribute("lang", fixedLangAttributeValue);
    }
    // Handle starting screen navigation for web component apps (only once)
    if (this.props.appMode === "WebComponent" && this.props.startingScreen && !this.hasNavigatedToStartingScreen) {
      this.hasNavigatedToStartingScreen = true;
      this.navigateToStartingScreen();
    }

    window.onfocus = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = true;
    };

    window.onblur = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = false;
    };

    if (!window.styler_speed) {
      window.styler_speed = 20;
    } else if (window.styler_speed < 500) {
      window.styler_speed += 100;
    }

    if (window?.kuika?.activeKuikaComponent !== undefined) {
      return;
    }
    const runTimeout = () => {
      this.timerId = setTimeout(() => {
        const allFormItems: NodeListOf<HTMLElement> = document.querySelectorAll(".kFormItem");
        if (allFormItems) {
          allFormItems.forEach((formItem) => {
            if (formItem.getAttribute("data-display-affected") === "true") {
              return;
            }
            const antFormItemControlInputContent: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input .ant-form-item-control-input-content"
            );
            const antFormItemControlInput: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input"
            );
            const antFormItemControl: HTMLElement = formItem.querySelector(".ant-form-item-control");

            if (
              antFormItemControlInputContent &&
              antFormItemControlInputContent.children &&
              antFormItemControlInputContent.children.length > 0
            ) {
              const formChild: HTMLElement = antFormItemControlInputContent.children[0] as HTMLElement;
              let calculatedDisplay: string = formChild.style.display;
              if (
                calculatedDisplay &&
                antFormItemControl &&
                antFormItemControlInput &&
                antFormItemControlInputContent
              ) {
                if (calculatedDisplay === "inline-flex" || calculatedDisplay === "inline-block") {
                  calculatedDisplay = "";
                  formItem.style.width = formChild.style.width ?? "auto";
                  formItem.style.display = "inline-block";
                  formItem.setAttribute("data-display-affected", "true");
                }
              }
            }
          });
        }
        this.componentDidMount();
      }, window.styler_speed);
    };

    runTimeout();

    setTimeout(() => {
      clearTimeout(this.timerId);
    }, 10000);
  };

  private getScreenInputPropKeys = (): string[] => {
    return Object.keys(this.props || {}).filter((k) => k && k.startsWith("screenInput_"));
  };

  private buildScreenInputsFromProps = (): Record<string, unknown> => {
    const screenInputs: Record<string, unknown> = {};
    this.getScreenInputPropKeys().forEach((key) => {
      const inputName = key.substring("screenInput_".length);
      screenInputs[inputName] = this.props[key];
    });
    return screenInputs;
  };

  private navigateToStartingScreen = () => {
    try {
      const screenName = this.props.startingScreen as string;
      const baseHash = screenName.startsWith("#") ? screenName : `#${screenName}`;
      const inputs = this.buildScreenInputsFromProps();
      const params = new URLSearchParams();

      Object.keys(inputs).forEach((k) => {
        const v = inputs[k];
        if (v !== undefined && v !== null) {
          params.append(k, typeof v === "string" ? v : JSON.stringify(v));
        }
      });

      const qs = params.toString();
      const hash = `${baseHash}${qs ? `?${qs}` : ""}`;

      if (window.location.hash !== hash) {
        window.location.hash = hash;
      }
    } catch (e) {
      console.error("Error navigating to starting screen:", e);
    }
  };

  render() {
    const KuikaRouter = this.KuikaRouter();
    return (
      <>
        <KuikaRouter>
          <Switch key="Switch">
                        <PrivateRoute exact path="/" component={HomePagecopy_Screen} />
                        <PrivateRoute exact path="/alisfatura" component={AlisFatura_Screen} />
            <PrivateRoute exact path="/homepagecopy" component={HomePagecopy_Screen} />
            <PrivateRoute exact path="/sairdekontlist" component={SairDekontList_Screen} />
            <PrivateRoute exact path="/bankadetay" component={BankaDetay_Screen} />
            <PrivateRoute exact path="/masraflist" component={MasrafList_Screen} />
            <PrivateRoute exact path="/skoleksiyonbazindasatis" component={SKoleksiyonBazindaSatis_Screen} />
            <PrivateRoute exact path="/ueakoleksiyonstok" component={UEAKoleksiyonStok_Screen} />
            <PrivateRoute exact path="/satisfatura" component={SatisFatura_Screen} />
            <PrivateRoute exact path="/kasalist" component={KasaList_Screen} />
            <PrivateRoute exact path="/ebatdetaysatis" component={EbatDetaySatis_Screen} />
            <PrivateRoute exact path="/ueadesenstok" component={UEADesenStok_Screen} />
            <PrivateRoute exact path="/musterilist" component={MusteriList_Screen} />
            <PrivateRoute exact path="/kredikartilist" component={KrediKartiList_Screen} />
            <PrivateRoute exact path="/leftmenu" component={LeftMenu_Screen} />
            <PrivateRoute exact path="/urunenvanteranalizi" component={UrunEnvanterAnalizi_Screen} />
            <Route exact path="/signup" component={Signup_Screen} />
            <PrivateRoute exact path="/musteridetay" component={MusteriDetay_Screen} />
            <PrivateRoute exact path="/tedarikcidetay" component={TedarikciDetay_Screen} />
            <PrivateRoute exact path="/urunsatisanaliz" component={UrunSatisAnaliz_Screen} />
            <PrivateRoute exact path="/homepage" component={HomePage_Screen} />
            <PrivateRoute exact path="/desendetaysatis" component={DesenDetaySatis_Screen} />
            <PrivateRoute exact path="/kasadetay" component={KasaDetay_Screen} />
            <Route exact path="/resetpassword" component={ResetPassword_Screen} />
            <Route exact path="/verificationcode" component={VerificationCode_Screen} />
            <Route exact path="/forgotpassword" component={ForgotPassword_Screen} />
            <PrivateRoute exact path="/alacakceksenetlist" component={AlacakCekSenetList_Screen} />
            <PrivateRoute exact path="/bankalist" component={BankaList_Screen} />
            <Route exact path="/signin" component={this.LoginComponent()} />
            <PrivateRoute exact path="/ueaebatstok" component={UEAEbatStok_Screen} />
            <PrivateRoute exact path="/ebatdetaysatinalma" component={EbatDetaySatinAlma_Screen} />
            <PrivateRoute exact path="/test" component={Test_Screen} />
            <PrivateRoute exact path="/borcceksenetlist" component={BorcCekSenetList_Screen} />
            <PrivateRoute exact path="/urunmaliyetanalizi" component={UrunMaliyetAnalizi_Screen} />
            <PrivateRoute exact path="/tedarikcilist" component={TedarikciList_Screen} />
            <PrivateRoute exact path="/sakoleksiyonbazindasatinalim" component={SAKoleksiyonBazindaSatinAlim_Screen} />
            <PrivateRoute exact path="/usercreate" component={Usercreate_Screen} />
            <PrivateRoute exact path="/desendetaysatinalma" component={DesenDetaySatinAlma_Screen} />
            <PrivateRoute exact path="/magazaciroanalizi" component={MagazaCiroAnalizi_Screen} />
            <PrivateRoute exact path="/profilescreen" component={ProfileScreen_Screen} />

            <Route path="/redirect" component={Redirect} />
            <Route path={"/login"} component={this.LoginComponent()} />
            
            
            <Route exact path="/forgotpassword" component={ForgotPassword} />
            <Route exact path="/resetpassword" component={ResetPassword} />
            <PrivateRoute exact path="/dashboard" component={Dashboard} />
            <Route exact path="/kuikainfo" component={KuikaInfo} />
            <Route exact path="/msalredirect" component={MsalRedirect} />
            <Route exact path="/wfmailinteraction" component={WFMailInteraction} />
            <PrivateRoute exact path="/scancomparetest" component={ScanCompareTest} />
            <Route exact path="/notificationredirect" component={NotificationRedirect} />
            <Route exact path="/logout" component={Redirect} />
            <Route path="*" component={NoMatch404} />
          </Switch>
        </KuikaRouter>
      </>
    );
  }

  KuikaRouter = () => {
    // Web component case
    let isWebComponentApp: any;
    isWebComponentApp = this.props.appMode === "WebComponent";
    if (
      confJson?.domainName !== undefined &&
      confJson?.applicationName !== undefined &&
      confJson?.applicationName !== "" &&
      window.kuika !== undefined &&
      window.kuika?.apps !== undefined &&
      window.kuika?.apps.length !== undefined &&
      window.kuika?.apps.length > 0
    ) {
      window.kuika?.apps.forEach((app: any) => {
        if (app.appName === confJson.applicationName && app.workspace === confJson.domainName) {
          isWebComponentApp = true;
        }
      });
    }
    if (window.kuika === undefined) {
      window.kuika = {};
    }
    window.kuika.isWebComponentApp = isWebComponentApp;

    if (isWebComponentApp === true || this.props.routerType === "HashRouter") {
      return (props: any) => {
        return <HashRouter key="HashRouter">{props.children}</HashRouter>;
      };
    }
    return (props: any) => {
      if (KMainFunctions.virtualDirectoryURL === "auto" || window?.location?.protocol === "file:") {
        return <BrowserRouter key="BrowserRouter">{props.children}</BrowserRouter>;
      }
      return (
        <BrowserRouter basename={KMainFunctions.virtualDirectoryURL} key="BrowserRouter">
          {props.children}
        </BrowserRouter>
      );
    };
  };

  LoginComponent = () => {
    if (this.props.authType === "MSAL") {
      return MsalLogin;
    }

    const { external_access_token } = this.props;
    const { external_refresh_token } = this.props;
    const { external_user } = this.props;
    // The host injects external_access_token as a short-lived MFE handoff JWT.
    // No refresh_token is involved — the microapp's own backend mints its
    // session cookies once the token is redeemed.
    if (external_access_token !== null && external_access_token !== undefined && external_access_token !== "") {
      return (props: any) => {
        return (
          <MfeLogin
            external_user={external_user}
            external_access_token={external_access_token}
            external_refresh_token={external_refresh_token}
          ></MfeLogin>
        );
      };
    }

    if (this.props.authType === "Kuika") {
      return Signin_Screen;
    }
    return <></>;
  };
}
